import type { JSX } from 'react';
import { ConfigSection } from '../components/ConfigSection.js';

export function SettingsPage(): JSX.Element {
  return (
    <ConfigSection
      title={"Configurações: limites de arquivo, políticas e compatibilidade"}
      description={"Área do plano que depende de código ou credencial externa."}
      blockedBy={[
      'Limites vêm do ambiente (`S3_*`, `RETENTION_*`) e ainda não são editáveis pela UI por decisão de segurança.'
]}
      planned={[
      'Flags e versão mínima de app, com auditoria de mudança.'
]}
    />
  );
}